import { Providers } from './Providers'

export const App: React.FC = () => {
  return (
    <>
      <Providers />
    </>
  )
}
